import { useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
function Retro() {
    const retroRef = useRef<HTMLDivElement>(null);

    return (
        <Row className="retro section section--100 section--background section--retro" ref={retroRef}>
            <Col className="retro__content">
                <h1 className="retro__content__heading">
                    Your Gateway to Digital Excellence
                </h1>
            </Col>
        </Row>
    );
}

export default Retro;

